module.exports = __webpack_public_path__ + "static/media/linkedin-payment-2-en.9c899176.png";